export default __webpack_public_path__ + "static/media/estimate-02.801adef0.mp4";